import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectLoaded } from '../../store/reducers/storage';
//import {selectStorage} from '../../store/reducers/storage';
import { getPKH } from '../../utils/wallet';
import { isLocalhost, BASE_URL } from '../../utils/isLocalEnvChecker';

import validator from 'validator'


const createItemInDb = async (params) => {
    var newPrams = {
        tokenId: params.tokenId,
        walletAddress: params.walletAddress,
        emailAddress: params.emailAddress,
        username: params.username,
        description: params.description ? params.description : '',
    }
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(newPrams)
    };
    let urlOfFunctions = BASE_URL;
    if (isLocalhost) {
        urlOfFunctions = 'http://localhost:8888/';
    }
    const response = await fetch(urlOfFunctions + '.netlify/functions/signup-create-v2', requestOptions);
    const data = await response.json();
    return data;
}

// end fauna

const Signup = () => {
    const loaded = useSelector(selectLoaded);
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState('');
    const [emailError, setEmailError] = useState('');
    const [descError, setDescError] = useState('');
    const [walletError, setWalletError] = useState('');
    //const storage = useSelector(selectStorage);
    const [userWalletAddress, setUserWalletAddress] = useState('');
    console.log(userWalletAddress);
   
    useEffect(() => {
        try {
            const func = async () => {
                console.log('check userWalletAddress');
                try {
                    const userWalletAddress = await getPKH();
                    // const canClaim = await checkClaim(userWalletAddress);
                    if (userWalletAddress) {
                        console.log('userWalletAddress', userWalletAddress);
                        setUserWalletAddress(userWalletAddress);
                        setWalletError('');
                    } else {
                        console.log('no wallet address found');
                        setWalletError('no wallet address. Please SYNC wallet with website.')
                    }
                } catch (err) {
                    console.log(err)
                    setWalletError('no wallet address. Please SYNC wallet with website.')
                }
                //console.log('check ',wallet);
                //dispatch(setStorage(nfts));
            };
            //if (!loaded) {
                func();
            //}
        } catch (err) {
            console.log(err);
        }
    }, [loaded, userWalletAddress]);

    const submit = async (event) => {
        try {
            event.preventDefault();
            setEmailError('');
            setDescError('');
            setWalletError('');
            if (validator.isEmail(event.target.emailAddress.value) === false) {
                console.log('invalid email');
                setEmailError('Please enter a valid email');
                return;
            }
            if ((event.target.description.value).length <= 30 || (event.target.description.value).length > 200) {
                console.log('invalid description');
                setDescError('Please enter at least 30 characters and less than 200 characters');
                return;
            }
            if (event.target.walletAddress.value === '') {
                console.log('no wallet address');
                // const func = async () => {
                //     await disconnectWallet();
                //     await connectWallet();
                // }
                // func();
                setWalletError('No wallet address. Please SYNC wallet with website.');
                return;
            }
            setLoading(true);
            // const pkh = await getPKH();
            // console.log('pkh ', pkh);
            // const address = userWalletAddress; //event.target.walletAddress.value; //event.target.walletAddress.value ? event.target.walletAddress.value : pkh;
            const params = {};
            params.tokenId = '';// will be set at mint time and record updated
            params.walletAddress = event.target.walletAddress.value;
            params.emailAddress = event.target.emailAddress.value;
            params.username = event.target.username.value;
            params.description = event.target.description.value;


            console.log(params);

            const op = await createItemInDb(params);

            console.log(op);
            setMessage('Signed up Successfully!');
            setLoading(false);
        } catch (err) {
            console.log(err);
            setLoading(false);
            setMessage('Error: Not able to signup');
        }
    };

    const closeMessage = () => {
        setMessage('');
    };

    // const validateEmail = (e) => {
    //   var email = e.target.value
    
    //   if (validator.isEmail(email)) {
    //     setEmailError('');
    //   } else {
    //     setEmailError('Please enter a valid email');
    //   }
    // }

    // const validateTextInput = (e) => {
    //     var desc = e.target.value
    //     if (desc.length >= 30 && desc.length <= 200) {
    //         setDescError('');
    //     } else {
    //         setDescError('Please enter at least 30 characters and less than 200 characters');
    //     }
    // }

    return (

        <section className="creep" id="">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 align-self-center">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="item">
                                    <h3>Signup for your Player NFT</h3>
                                    {/* <p>Distillery viral photo booth literally williamsburg semiotics iceland. Kinfolk pug sustainable
                                        flannel keffiyeh messenger bag aesthetic craft beer coloring book. Flannel lyft hella, blue bottle
                                        kombucha copper mug tbh yuccie irony. Coloring book vegan vape unicorn yr, single-origin coffee
                                        listicle mustache beard whatever 3 wolf moon disrupt pinterest scenester.</p>
                                    <p>Schlitz seitan hot chicken, meggings lo-fi knausgaard before they sold out skateboard shoreditch
                                        tumeric iceland small batch. Raclette live-edge tumblr cray hot chicken 90's 3 wolf moon four loko
                                        letterpress vaporware heirloom gochujang. Celiac pitchfork letterpress vaporware. Cardigan neutra fam
                                        literally kombucha. Migas post-ironic vice banh mi, kinfolk unicorn narwhal. Truffaut vice activated
                                        charcoal edison bulb hammock church-key.</p> */}
                                    <div className="container">
                                        {message && (
                                            <div className="position-fixed bottom-0 end-0 p-3" style={{ zIndex: 11 }}>
                                                <div
                                                    id="liveToast"
                                                    className="toast fade show d-flex"
                                                    role="alert"
                                                    aria-live="assertive"
                                                    aria-atomic="true"
                                                >
                                                    <div className="toast-body">{message}</div>
                                                    <button type="button" className="btn-close me-2 m-auto" onClick={closeMessage}></button>
                                                </div>
                                            </div>
                                        )}
                                        <form onSubmit={submit}>
                                            {/* <div className="mb-3">
                    <label htmlFor="tokenId" className="form-label">
                        Token ID
                    </label>
                    <input
                        type="number"
                        className="form-control"
                        id="tokenId"
                        aria-describedby="tokenId"
                        required
                        value={(storage.length + 1)}
                        disabled
               />
                </div>  */}
                                            <div className="mb-3">
                                                <label htmlFor="walletAddress" className="form-label">
                                                    Wallet Address
                                                </label>
                                                <input type="text" className="form-control" id="walletAddress" aria-describedby="wallet Address" defaultValue={userWalletAddress} disabled />
                                                <br />
                                                <span style={{
                                                  fontWeight: 'bold',
                                                  color: 'red',
                                                }}>{walletError}</span>
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="emailAddress" className="form-label">
                                                    Email Address
                                                </label>
                                                <input type="text" className="form-control" id="emailAddress" 
                                             aria-describedby="email Address" required /><br />
                                            <span style={{
                                            fontWeight: 'bold',
                                            color: 'red',
                                            }}>{emailError}</span>
                                            </div>
                                            <div className="mb-3">
                                                {/* <label htmlFor="username" className="form-label">
                                                Username
                                            </label> */}
                                                <input type="text" className="form-control" id="username" aria-describedby="username" defaultValue={"testuser"} hidden={true} required />
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="description" className="form-label">
                                                    Nightmare Description
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    id="description"
                                                    aria-describedby="description"
                                                    required
                                                /><br />
                                                <span style={{
                                                  fontWeight: 'bold',
                                                  color: 'red',
                                                }}>{descError}</span>
                                            </div>
                                            {/* <div className="mb-3">
                                            <label htmlFor="image" className="form-label">
                                                Image
                                            </label>
                                            <input className="form-control" type="file" id="image" accept="image/*" required />
                                            </div> */}
                                            <button type="submit" className="btn main-button-red-submit" disabled={!loaded || loading}>
                                                {loading && (
                                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                                )}
                                                Sign up
                                            </button>
                                        </form>
                                    </div>






{/* 
                                    <div className="main-button-red">
                                        <div className="scroll-to-section"><a href="#REMOVETHIS">Sign up</a></div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>















    );
};

export default Signup;
